.error-message {
    max-width: 400px;
    /* same as shared-styles truncate */
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.two-pane-modal-form-container {
    display: flex;
    gap: 48px;
    height: calc(100% - 82px);
}

.left-section {
    /* Just want to scroll the left section */
    overflow-y: auto;
    height: 100%;
    padding-right: 16px;
}
